import React, { Component, Fragment } from 'react';
import { Container } from "@mui/material";
import Header from "../components/services/header";
import Content from "../components/services/content";
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';
class Services extends Component {

    render() {
        return (
            <Fragment>
                <ResponsiveAppBar />
                <Container maxWidth="xl" className="pageHeight">
                    <Header />
                    <Content />
                </Container>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default Services;